import { render, staticRenderFns } from "./CompartilharDocs.vue?vue&type=template&id=5a98085c&"
import script from "./CompartilharDocs.vue?vue&type=script&lang=js&"
export * from "./CompartilharDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports